import React from 'react';

const SvgEg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="EG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="EG_svg__b" fill="#fff">
        <use xlinkHref="#EG_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#E41D33" mask="url(#EG_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#262626" mask="url(#EG_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M11 8.66v2.68c0 .097-.049.07.028.018l1.454-.969.185-.056h1v1c0 .186.148.334.333.334a.332.332 0 0 0 .333-.334v-1h1l.185.056 1.454.97c.079.052.028.08.028-.02V8.661a.334.334 0 0 0-.333-.328h-.33a.254.254 0 0 0-.187.112l-.817 1.634-.298-.597a4.293 4.293 0 0 0-.385-.615c-.254-.339-.498-.534-.65-.534a.274.274 0 0 0-.119.042c-.146.08-.324.256-.51.496-.18.234-.328.47-.412.623l-.306.557-.803-1.606c-.025-.05-.126-.112-.186-.112h-.33a.329.329 0 0 0-.334.328z"
        stroke="#C6A846"
        strokeWidth={0.667}
        fillOpacity={0.25}
        fill="#F4B32E"
        mask="url(#EG_svg__b)"
      />
    </g>
  </svg>
);

export default SvgEg;
